import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useQueryClient } from 'react-query';
import DatePicker from '../../components/forms/formDatePicker';
import EmployeeSelect from '../../components/selects/employeeSelect';
import FormInput from '../../components/forms/formInput';

const FilterIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
);
const ChevIcon = () => (
    <svg className="ic chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const PayrollsFilter = ({ isFiltering, onFilter }) => {
    const { t } = useTranslation();

    const [isShow, setIsShow] = useState(false)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [employeeId, setEmployeeId] = useState('')
    const [rateType, setRateType] = useState('')
    const queryClient = useQueryClient()

    const activeCount = [dateFrom, dateTo, employeeId, rateType].filter(Boolean).length

    const handleFilter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onFilter([
            dateFrom ? new Date(dateFrom.setHours(0, 0, 0, 0)) : '',
            dateTo ? new Date(dateTo.setHours(23, 59, 59, 999)) : '',
            employeeId ?? '',
            rateType ?? ''
        ])
    }

    const handleReset = () => {
        onFilter(['', '', ''])
        setDateFrom('')
        setDateTo('')
        setEmployeeId('')
        setRateType('')
        queryClient.invalidateQueries(['payrolls', 'paginated'])
    }

    return (
        <>
            <button type="button" className={`filter-toggle${isShow ? ' on' : ''}`} onClick={() => setIsShow(s => !s)}>
                <FilterIcon /> {t('payroll.filters')}
                {activeCount > 0 && <span className="cnt">{activeCount}</span>}
                <ChevIcon />
            </button>

            {isShow && (
                <Form onSubmit={handleFilter} className="filter-panel">
                    <div className="filter-grid">
                        <DatePicker className="form-control" label={t('payroll.dateFrom')} placeholderText={t('payroll.filterDateFrom')}
                            selected={dateFrom} onChange={setDateFrom} maxDate={dateTo || undefined} dateFormat="dd.MM.yyyy" />
                        <DatePicker className="form-control" label={t('payroll.dateTo')} placeholderText={t('payroll.filterDateTo')}
                            selected={dateTo} onChange={setDateTo} minDate={dateFrom || undefined} dateFormat="dd.MM.yyyy" />
                        <EmployeeSelect required value={employeeId} label={t('payroll.employee')} placeholder={t('payroll.employee')}
                            onChange={(option) => setEmployeeId(option.value)} includeAll={true} />
                        <FormInput as="select" label={t('payroll.rateType')} placeholder={t('payroll.selectRateType')}
                            value={rateType} onChange={(e) => setRateType(e.target.value)}>
                            <option value="">{t('payroll.allRateType')}</option>
                            <option value="HOURLY">{t('payroll.hourly')}</option>
                            <option value="DAILY">{t('payroll.daily')}</option>
                            <option value="FIXED_MONTHLY">{t('payroll.fixedMonthly')}</option>
                        </FormInput>
                    </div>

                    <div className="filter-foot">
                        <span className="meta">
                            {activeCount > 0 ? (activeCount === 1 ? t('payroll.filterSelected') : t('payroll.filtersSelected', { count: activeCount })) : t('payroll.noFiltersApplied')}
                        </span>
                        <div className="sp">
                            <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={handleReset}>{t('payroll.reset')}</button>
                            <button type="submit" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isFiltering}>
                                {isFiltering ? t('payroll.filtering') : t('payroll.applyFilters')}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </>
    )
}

export default PayrollsFilter
